/*----------------------------------------------------

	tabs.js

----------------------------------------------------*/


/* click event
----------------------------------------------------------------------------------------------------*/

var tab_links = document.querySelectorAll('a[data-tab],[data-tab] a');

if(tab_links.length > 0){

  [].forEach.call(tab_links, function(link){
    
    link.addEventListener('click', function(ev){

      // Prevent the default link behavior
      ev.preventDefault();
      ev.stopPropagation();

      updateTabs(link);

    });

  });

  // run on load
  updateProductTabs();

}

/* change tab content
----------------------------------------------------------------------------------------------------*/

function updateTabs(clicked){

  var target = (clicked.dataset.tab) ? document.querySelector(clicked.dataset.tab) : document.querySelector(clicked.getAttribute('href'));

  // remove show from siblings
  Array.from(target.parentNode.children).forEach(function(child){
    if(child !== target){
        child.classList.remove('show');
    }
  });

  // add show clas to target
  target.classList.add('show');

  updateProductTabs();

}


/* change tab state
----------------------------------------------------------------------------------------------------*/

function updateProductTabs(){

  let current_style_id = null;

  // find currently visible tab
  document.querySelectorAll('.product-options__style').forEach(style => {
    if(isVisible(style)){
      current_style_id = style.id;
    }
  });

  // remove existing current class
  var existing = document.querySelector('.product-options__tabs').querySelectorAll('.current');
  if(existing){
    existing.forEach(e => {
      e.classList.remove('current');
    });
  }

  // add class to relevant <a>
  if(current_style_id){
    const current_tab = document.querySelector(`[href="#${current_style_id}"]`);
    current_tab.classList.add('current');
  }

}